import enrollment from '@/api/student-enrollment'

import { baseState, baseMutations } from '@/store/mixins'
import { join } from 'lodash'

export const state = {
  ...baseState,
  edit_data: {},
  classOperations: [],
  student_status_id: [],
  status: [1],
  // ac_status_id: [],
  ac_status_id: 1,
  ac_year: [],
  subProgramList: [],
  acps_id: [],
  termListFilter: [],
  acTermFilter: [],
  studyTimes: [],
  ac_st_id: [],

}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_EDIT_DATA(state, data) {
    state.edit_data = data
  },
  SET_STATUS_VALUE(state, value) {
    state.status = value
  },
  SET_ACADEMIC_YEAR_VALUE(state, value) {
    state.ac_year = value
  },
  SET_STUDENT_STATUS_VALUE(state, value) {
    state.student_status_id = value.length > 0 ? value : [1]
  },
  SET_AC_STATUS(state, acStatusId) {
    state.ac_status_id = acStatusId
  },
  SET_SUB_PROGRAM_LIST(state, data) {
    state.subProgramList = data || []
  },
  SET_ACPS_ID(state, value) {
    state.acps_id = value
  },
  SET_TERM_LIST_FILTER(state, data) {
    state.termListFilter = data || []
  },
  SET_ACTERM_ID_FILTER(state, data) {
    state.acTermFilter = data
  },
  RESET_CASCADE_FROM_YEAR(state) {
    state.subProgramList = []
    state.acTermFilter = []
  },
  RESET_CASCADE_FROM_SUB_PROGRAM(state) {
    state.termListFilter = []
    state.acTermFilter = []
  },
  SET_STUDY_TIME_LIST(state, data) {
    state.studyTimes = data
  },
  SET_AC_ST_ID(state, value) {
    state.ac_st_id = value
  },

}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        student_status_id: context.state.student_status_id,
        ac_year: context.state.ac_year,
        acps_id: context.state.acps_id,
        ac_st_id: context.state.ac_st_id,
        ac_term_id: context.state.acTermFilter.join(','), filter: {
          ac_status_id: join(context.state.status, ','),
        }
      },
      attrubutes
    )
    return enrollment.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return enrollment.store(data)
  },

  update(context, data) {
    return enrollment.update(data)
  },
  destroy(context, id) {
    return enrollment.destroy(id)
  },
  storeStudentForward(context, data) {
    return enrollment.forwardClass(data)
  },
  accelerateStudent(context, data) {
    return enrollment.accelerateStudent(data)
  },

  async getClassOperation(context, attrubutes = {}) {
    let params = Object.assign(
      {
        filter: {
          ac_status_id: context.state.ac_status_id
        }
      },
      attrubutes
    )
    return await enrollment.getClass({ params })
  },
  async getStudent(context, params = {}) {
    return await enrollment.getStudent({ params })
  },
  fetchStudentEnrollByClass(context, attrubutes = {}) {
    return enrollment.get({ params: attrubutes })
  },
  updateSession(context, data) {
    return enrollment.updateSession(data)
  },
  async getSession(context) {
    let response = await enrollment.formViewModel({
      params: {
        fnName: 'sessions'
      }
    })
    return {
      data: response.data['sessions']
    }
  },
  getClassOfNextGrade(context, { gradeId, params }) {
    return enrollment.getClassOfNextGrade({ gradeId, params })
  },
  async getStudyTime(context, attributes = {}) {
    let response = await enrollment.formViewModel({
      params: {
        fnName: 'study_time',
        ...attributes
      }
    })
    return {
      data: response.data['study_time']
    }
  },
  async getYear(context, attributes = {}) {
    let response = await enrollment.formViewModel({
      params: {
        fnName: 'academic_year',
        ...attributes
      }
    })
    return {
      data: response.data['academic_year']
    }
  },
  async getSubProgramByYear(context, yearIds = []) {
    context.commit('RESET_CASCADE_FROM_YEAR')
    if (!yearIds.length) {
      return
    }
    let response = await enrollment.formViewModel({
      params: {
        fnName: 'sub_program_by_year',
        ac_year_id: yearIds.join(',')
      }
    })
    context.commit(
      'SET_SUB_PROGRAM_LIST',
      response.data['sub_program_by_year'] || []
    )
  },
  async getTermBySubProgram(context, acpsIds = []) {
    context.commit('RESET_CASCADE_FROM_SUB_PROGRAM')
    if (!acpsIds.length) {
      return
    }

    const acYearIds = context.state.ac_year || []

    let response = await enrollment.formViewModel({
      params: {
        fnName: 'term_by_sub_program',
        acps_id: acpsIds.join(','),
        ac_year_id: acYearIds.join(',')
      }
    })
    context.commit(
      'SET_TERM_LIST_FILTER',
      response.data['term_by_sub_program'] || []
    )
  },
  async getStudyTime(context) {
      let response = await enrollment.formViewModel({
        params: { fnName: 'study_time' }
      })
      context.commit('SET_STUDY_TIME_LIST', response.data.study_time)
      return {
        data: response.data['study_time']
      }
  },


}
